import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { Color } from 'ng2-charts';

@Component({
  selector: 'app-discussion-tv-social-chart',
  templateUrl: './discussion-tv-social-chart.component.html',
  styleUrls: ['./discussion-tv-social-chart.component.scss', '../discussion-total-report-chart/discussion-total-report-chart.component.scss']
})
export class DiscussionTvSocialChartComponent {
  @Input() dataReport: any;
  @Input() interval: string = 'day';
  title_report = '';
  dataKeys = [];
  dataAggs = {};

  //barchart
  public barChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: 'bottom'
    },

    // We use these empty structures as placeholders for dynamic theming.
    plugins: {
      //exportEnabled: 1,
      labels: false,
      datalabels: {
        anchor: 'end',
        align: 'end',
      },
      tooltip: '1',
    }
  };
  public barChartLabels: any[] = ['Bài viết', 'Bài báo', 'Bình luận', 'Lượt thích', 'Chia sẻ', 'ND tích cực', 'ND tiêu cực'];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartColors: Color[] = [
    { backgroundColor: ["#0082bf", "#abe4ff"] },
    { backgroundColor: ["#0082bf", "#abe4ff"] }
  ];

  public barChartData = [
    { data: [], label: 'Series A' },
    { data: [], label: 'Series B' },
    { data: [], label: 'Series B' },
    { data: [], label: 'Series B' },
  ];


  //linechart
  public lineChartData = [];
  public lineChartLabels = [];
  public lineChartOptions = {
    responsive: true,
    legend: {
     display: true,
     position: 'bottom'
    },
  };
  public lineChartColors: Color[] = [];
  public lineChartLegend = true;
  public lineChartType = 'line';

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    this.mappingData()
  }

  mappingData() {
    if (this.dataReport && this.dataReport.data) {
      this.dataKeys = Object.keys(this.dataReport.data.dataAggs);
      this.dataAggs = this.dataReport.data.dataAggs;
      this.mappingBarchart();
      this.mappingLineChart();
    }
  }

  mappingBarchart() {
    let colorGeneral = this.dataReport.data.colorGeneral;
    this.barChartColors = [];
    this.barChartData = [];

    for (let key in this.dataAggs) {
      this.barChartData.push({
        label: key,
        data: [
          (this.dataAggs[key].statistic.post.doc_count + this.dataAggs[key].statistic.news.doc_count),
          this.dataAggs[key].statistic.news.doc_count,
          this.dataAggs[key].statistic.comments.doc_count,
          this.dataAggs[key].statistic.post.likeCount.value,
          this.dataAggs[key].statistic.post.shareCount.value,
          this.dataAggs[key].statistic.positive.statistic.statistic.doc_count,
          this.dataAggs[key].statistic.negative.statistic.statistic.doc_count
        ]
      });
      let bgColor = (new Array(7)).fill(colorGeneral[key]);
      this.barChartColors.push({
        backgroundColor: bgColor
      })
    }
  }

  mappingLineChart() {
    let colorGeneral = this.dataReport.data.colorGeneral;
    this.lineChartColors = [];
    this.lineChartData = [];
    for (let key in this.dataAggs) {
      const labels =this.dataAggs[key] && this.dataAggs[key].byDay && this.dataAggs[key].byDay.buckets ? this.dataAggs[key].byDay.buckets  : [];
      if(labels && labels.length) {
        this.lineChartLabels =labels.map(c => this.getLabelByInterval(c.key_as_string));
        break;
      }
    }
    for (let key in this.dataAggs) {
      let data = this.dataAggs[key].byDay.buckets.map(c => c.doc_count);
      this.lineChartData.push({
        label: key,
        data
      });
      this.lineChartColors.push({
        borderColor: colorGeneral[key],
        pointBorderColor: colorGeneral[key],
        backgroundColor: 'transparent'
      })
    }
  }

  getLabelByInterval(dateString) {
    let date = moment(dateString);
    if (date.isValid()) {
      switch (this.interval) {
        case 'month':
          return date.format('MMM-YYYY');
        case 'year':
          return date.year();
        default:
          return date.format('DD-MMM');
      }
    }
    return '';
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/discussion-tv-social-chart/discussion-tv-social-chart.component.ts